module.exports = __webpack_public_path__ + "assets/e1e7d8e0066f97617b28d450bb506b25.mp3";